import type { Box } from '../strangler'

// The ending's time-stop flag (pristine: script.js:1292 init; :1300/:2195
// tick guards; :2521-2527 timeStopStart toggles). Distinct from the proper
// Pause/Resume planned for step 13. Future owner: engine ending state.
export const timeStopped: Box<boolean> = { value: false }
